import { push } from 'react-router-redux';
import handleErrorResponse from '../../../helpers/handleErrorResponse';
import Axios from 'axios/index';

const createTrackingLinkBroker = (resource) => {
  return (dispatch) => {
    return Axios.post('brokers', resource)
      .then((response) => {
        dispatch(push('/admin/tracking-links/' + response.data.data.id)); //redirect to broker page
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error creating the broker');
      });
  };
};

const updateTrackingLinkBroker = (resource) => {
  return (dispatch) => {
    return Axios.patch('brokers/' + resource.data.id, resource)
      .then((response) => {
        dispatch(push('/admin/tracking-links/' + response.data.data.id)); //redirect to broker page
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error creating the broker');
      });
  };
};

export const actions = {
  updateTrackingLinkBroker,
  createTrackingLinkBroker,
};
